export interface PortoApolice {
  codigoConvenio: string | null;
  codigoEmpresa: string;
  codigoRamo: string;
  codigoSituacaoApolice: string;
  codigoTipoSeguro: string;
  dataEmissao: string;
  dataFinalVigencia: string;
  dataInicioVigencia: string;
  nomeEmpresa: string;
  numeroDigitoApolice: string;
  itens: {
    documentos: {
      segurado: {
        codigoSexo: string;
        dataNascimento: string;
        digitoCpfouCnpj: string;
        enderecos: {
          codigoDdd: string;
          codigoUnidadeFederacao: string;
          complementoEndereco: string;
          nomeBairro: string;
          nomeCidade: string;
          nomeLogradouro: string;
          nomeTipoLogradouro: string;
          numeroComplementoCep: string;
          numeroInicioCep: string;
          numeroLogradouro: string;
          textoNumeroTelefoneRamal: string;
        };
        enderecosEletronicos: {
          enderecoEletronico: string;
        };
        nomeSegurado: string;
        numeroCpfouCnpj: string;
        numeroOrdemCnpj: string;
      };
      veiculo: {
        anoFabricacaoVeiculo: string;
        anoModeloVeiculo: string;
        codigoUsoVeiculo: string;
        finalNumeroChassi: string;
        inicioNumeroChassi: string;
        nomeCombustivelVeiculo: string;
        nomeMarcaVeiculo: string;
        nomeModeloVeiculo: string;
        nomeTipoVeiculo: string;
        quantidadePortaVeiculo: string;
      };
    };
  };
  Beneficios: [];
}

export interface PortoApoliceResponse {
  Apolices: { Apolice: PortoApolice }[];
}

export const ApoliceLogo: Record<string, string> = {
  PORTO: '/images/porto-seguro.png',
  MITSUI: '/images/mitsui-seguros.png',
  ITAU: '/images/itau-seguros.png',
  AZUL: '/images/azul-seguros.png',
};

export enum PortoApoliceType {
  PORTO = 'PORTO',
  MITSUI = 'MITSUI',
  ITAU = 'ITAU',
  AZUL = 'AZUL',
}
